import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-chevron-expand',
	templateUrl: './icon-chevron-expand.component.svg',
})
export class IconChevronExpandComponent {}
